import './style.scss';

import React from 'react';

export default function RadioButton(props) {
  const inputClass =
    'radio-button__input' + (props.inputClass ? ` ${props.inputClass}` : '');
  const btnClass =
    'radio-button__circle' + (props.btnClass ? ` ${props.btnClass}` : '');
  const labelClass =
    'radio-button__label' +
    (props.labelClass ? ` ${props.labelClass}` : '') +
    (props.disabled ? ' radio-button__label--disabled' : '');

  return (
    <div className={props.containerClass}>
      <input
        className={inputClass}
        type="radio"
        id={props.id}
        name={props.name}
        checked={props.checked}
        onChange={props.onChange}
        disabled={props.disabled}
      />
      <label htmlFor={props.id} className={labelClass}>
        <div className={btnClass} />
        {props.children}
      </label>
    </div>
  );
}



// WEBPACK FOOTER //
// ./shared/components/ui/radioButton/index.js